export default __webpack_public_path__ + "static/media/Mc001-Picture1.b70b69ef.png";